import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const DAILY_DATA = [
  { date: 'May 1', acres: 2840, cost: 18200, fuel: 4200, hours: 14.2 },
  { date: 'May 2', acres: 3120, cost: 19400, fuel: 4600, hours: 15.1 },
  { date: 'May 3', acres: 1200, cost: 12100, fuel: 2800, hours: 8.5 },
  { date: 'May 4', acres: 3340, cost: 20100, fuel: 4900, hours: 15.8 },
  { date: 'May 5', acres: 3510, cost: 21500, fuel: 5100, hours: 16.2 },
  { date: 'May 6', acres: 2950, cost: 18900, fuel: 4400, hours: 14.5 },
  { date: 'May 7', acres: 0, cost: 2200, fuel: 0, hours: 0 },
  { date: 'May 8', acres: 3280, cost: 20400, fuel: 4800, hours: 15.5 },
  { date: 'May 9', acres: 3150, cost: 19800, fuel: 4500, hours: 15.0 },
  { date: 'May 10', acres: 3420, cost: 21200, fuel: 5000, hours: 16.0 },
  { date: 'May 11', acres: 3080, cost: 19600, fuel: 4400, hours: 14.8 },
  { date: 'May 12', acres: 2100, cost: 15800, fuel: 3600, hours: 11.5 },
];

const EQUIP_EFF = [
  { name: 'Seed Hawk #1', acPerHr: 22.4, uptime: 94, fuelPerAc: 1.42 },
  { name: 'Seed Hawk #2', acPerHr: 21.8, uptime: 91, fuelPerAc: 1.48 },
  { name: 'Pro-Till #1', acPerHr: 28.5, uptime: 88, fuelPerAc: 1.15 },
  { name: 'Pro-Till #3', acPerHr: 27.2, uptime: 82, fuelPerAc: 1.22 },
];

export default function AnalyticsPage() {
  const [timeRange, setTimeRange] = useState('season');
  const [data] = useState(DAILY_DATA);
  useEffect(function() { /* Future: fetch from supabase */ }, []);

  var totalAc = data.reduce(function(s,d){return s+d.acres;},0);
  var totalCost = data.reduce(function(s,d){return s+d.cost;},0);
  var totalFuel = data.reduce(function(s,d){return s+d.fuel;},0);
  var workDays = data.filter(function(d){return d.acres>0;}).length;
  var avgAcDay = Math.round(totalAc / workDays);
  var costPerAc = (totalCost / totalAc).toFixed(2);
  var fuelPerAc = (totalFuel / totalAc).toFixed(2);
  var maxAc = Math.max.apply(null, data.map(function(d){return d.acres;}));
  var progress = ((totalAc / 52000) * 100).toFixed(1);
  var fmt = function(n) { return '$'+n.toLocaleString('en-CA',{minimumFractionDigits:2,maximumFractionDigits:2}); };
  var barH = function(v) { return maxAc>0 ? (v/maxAc)*100 : 0; };

  return (
    <div className="page-container">
      <div className="page-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' }}>
        <div>
          <h1 style={{ margin: 0, color: 'var(--text)' }}>Analytics</h1>
          <p style={{ margin: '4px 0 0', color: 'var(--text-secondary)', fontSize: '0.9rem' }}>Performance metrics - 52,000 acre seeding operation</p>
        </div>
        <div style={{ display: 'flex', gap: '0.5rem' }}>
          {['week','season'].map(function(r){ return <button key={r} onClick={function(){setTimeRange(r);}} style={{ background: timeRange===r ? 'var(--primary)' : 'var(--surface)', color: timeRange===r ? '#fff' : 'var(--text)', border: '1px solid', borderColor: timeRange===r ? 'var(--primary)' : 'var(--border)', borderRadius: '8px', padding: '0.4rem 1rem', cursor: 'pointer', textTransform: 'capitalize' }}>{r}</button>; })}
        </div>
      </div>

      <div className="stats-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
        {[
          {l:'Total Acres',v:totalAc.toLocaleString(),sub:progress+'% of 52,000',c:'var(--primary)'},
          {l:'Avg Acres/Day',v:avgAcDay.toLocaleString(),sub:workDays+' working days',c:'var(--primary)'},
          {l:'Cost/Acre',v:fmt(parseFloat(costPerAc)),sub:'Total: '+fmt(totalCost),c:'#3b82f6'},
          {l:'Fuel/Acre',v:fmt(parseFloat(fuelPerAc)),sub:'Total fuel: '+fmt(totalFuel),c:'#f59e0b'},
          {l:'Season Progress',v:progress+'%',sub:(52000-totalAc).toLocaleString()+' remaining',c:'var(--primary)'},
        ].map(function(s){
          return (
            <div key={s.l} className="stat-card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.25rem' }}>
              <div style={{ color: 'var(--text-secondary)', fontSize: '0.8rem', marginBottom: '0.25rem' }}>{s.l}</div>
              <div style={{ color: s.c, fontSize: '1.8rem', fontWeight: 700 }}>{s.v}</div>
              <div style={{ color: 'var(--text-secondary)', fontSize: '0.75rem', marginTop: '0.25rem' }}>{s.sub}</div>
            </div>
          );
        })}
      </div>

      <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem', marginBottom: '1.5rem' }}>
        <h3 style={{ color: 'var(--text)', marginTop: 0, marginBottom: '1rem' }}>Acres Seeded Per Day</h3>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '6px', height: '200px', padding: '0 0.5rem' }}>
          {data.map(function(day, i) {
            var h = barH(day.acres);
            var bg = day.acres===0 ? 'var(--border)' : day.acres>=3000 ? 'var(--primary)' : day.acres>=2000 ? 'var(--secondary)' : '#f59e0b';
            return (
              <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px' }}>
                <span style={{ color: 'var(--text-secondary)', fontSize: '0.65rem' }}>{day.acres>0 ? day.acres.toLocaleString() : '-'}</span>
                <div style={{ width: '100%', maxWidth: '40px', height: h+'%', minHeight: day.acres>0 ? '4px' : '2px', background: bg, borderRadius: '4px 4px 0 0' }} />
                <span style={{ color: 'var(--text-secondary)', fontSize: '0.65rem', whiteSpace: 'nowrap' }}>{day.date.replace('May ','M')}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1rem', marginBottom: '1.5rem' }}>
        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
          <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Equipment Efficiency</h3>
          {EQUIP_EFF.map(function(eq) {
            return (
              <div key={eq.name} style={{ marginBottom: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
                  <span style={{ color: 'var(--text)', fontWeight: 600 }}>{eq.name}</span>
                  <span style={{ color: 'var(--primary)', fontWeight: 600 }}>{eq.acPerHr} ac/hr</span>
                </div>
                <div style={{ display: 'flex', gap: '1rem', fontSize: '0.8rem' }}>
                  <span style={{ color: 'var(--text-secondary)' }}>Uptime: <strong style={{ color: eq.uptime>=90 ? '#22c55e' : '#f59e0b' }}>{eq.uptime}%</strong></span>
                  <span style={{ color: 'var(--text-secondary)' }}>Fuel: <strong style={{ color: 'var(--text)' }}>{fmt(eq.fuelPerAc)}/ac</strong></span>
                </div>
                <div style={{ marginTop: '0.5rem', background: 'var(--bg)', borderRadius: '4px', height: '6px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: eq.uptime+'%', background: eq.uptime>=90 ? 'var(--primary)' : '#f59e0b', borderRadius: '4px' }} />
                </div>
              </div>
            );
          })}
        </div>
        <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
          <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Cost Breakdown</h3>
          {[
            {l:'Fuel & Diesel',amt:totalFuel,pct:Math.round((totalFuel/totalCost)*100),c:'#f59e0b'},
            {l:'Seed & Chemical',amt:totalCost*0.38,pct:38,c:'#22c55e'},
            {l:'Labour',amt:totalCost*0.22,pct:22,c:'#3b82f6'},
            {l:'Parts & Repairs',amt:totalCost*0.06,pct:6,c:'#ef4444'},
            {l:'Other',amt:totalCost*0.05,pct:5,c:'#6b7280'},
          ].map(function(item) {
            return (
              <div key={item.l} style={{ marginBottom: '1rem' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.35rem' }}>
                  <span style={{ color: 'var(--text)', fontSize: '0.9rem' }}>{item.l}</span>
                  <span style={{ color: item.c, fontWeight: 600, fontSize: '0.9rem' }}>{fmt(item.amt)} ({item.pct}%)</span>
                </div>
                <div style={{ background: 'var(--bg)', borderRadius: '4px', height: '8px', overflow: 'hidden' }}>
                  <div style={{ height: '100%', width: item.pct+'%', background: item.c, borderRadius: '4px' }} />
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="card" style={{ background: 'var(--surface)', borderRadius: '12px', padding: '1.5rem' }}>
        <h3 style={{ color: 'var(--text)', marginTop: 0 }}>Season Progress</h3>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
          <span style={{ color: 'var(--text)' }}>{totalAc.toLocaleString()} / 52,000 acres</span>
          <span style={{ color: 'var(--primary)', fontWeight: 700 }}>{progress}%</span>
        </div>
        <div style={{ background: 'var(--bg)', borderRadius: '8px', height: '24px', overflow: 'hidden' }}>
          <div style={{ height: '100%', width: progress+'%', background: 'linear-gradient(90deg, var(--primary), var(--secondary))', borderRadius: '8px' }} />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', color: 'var(--text-secondary)', fontSize: '0.85rem', marginTop: '0.5rem' }}>
          <span>Est. days remaining: <strong style={{ color: 'var(--text)' }}>{Math.ceil((52000-totalAc)/avgAcDay)}</strong></span>
          <span>Pace: <strong style={{ color: 'var(--primary)' }}>{avgAcDay.toLocaleString()} ac/day</strong></span>
        </div>
      </div>
    </div>
  );
}